import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Privacy = () => {
  return (
    <main className="min-h-screen bg-slate-50">
      {/* Header */}
      <section className="bg-white border-b border-slate-100">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-12 md:py-16">
          <Link to="/" className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-6" data-testid="privacy-back-link">
            <ArrowLeft className="h-4 w-4" />
            Înapoi
          </Link>
          <h1 className="font-display text-3xl md:text-4xl font-bold text-slate-900" data-testid="privacy-title">
            Politica de confidențialitate
          </h1>
          <p className="text-slate-600 mt-2">Ultima actualizare: Ianuarie 2026</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <h2 className="font-display text-xl font-semibold text-slate-900 mt-0">
                1. Introducere
              </h2>
              <p className="text-slate-600 leading-relaxed">
                AnDeni Time Solutions SRL respectă confidențialitatea datelor dumneavoastră 
                personale și se angajează să le protejeze în conformitate cu Regulamentul 
                General privind Protecția Datelor (GDPR) și legislația română în vigoare.
              </p>
              <p className="text-slate-600 leading-relaxed">
                Această politică descrie ce date personale colectăm, cum le folosim și 
                care sunt drepturile dumneavoastră privind aceste date.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                2. Date colectate
              </h2>
              <p className="text-slate-600 leading-relaxed">
                În funcție de serviciile solicitate, putem colecta următoarele categorii 
                de date personale:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li><strong>Date de identificare:</strong> nume, prenume, CNP/CUI, adresă</li>
                <li><strong>Date de contact:</strong> email, număr de telefon</li>
                <li><strong>Date despre vehicul:</strong> marca, serie șasiu, număr înmatriculare</li>
                <li><strong>Documente:</strong> copii ale documentelor necesare procesării dosarului</li>
                <li><strong>Date de autentificare:</strong> informații din contul Google (dacă utilizați autentificarea Google)</li>
              </ul>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                3. Scopul prelucrării
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Datele dumneavoastră personale sunt prelucrate în următoarele scopuri:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li>Furnizarea serviciilor solicitate</li>
                <li>Comunicarea cu dumneavoastră privind stadiul dosarului</li>
                <li>Îndeplinirea obligațiilor legale</li>
                <li>Îmbunătățirea serviciilor noastre</li>
              </ul>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                4. Temeiul legal
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Prelucrăm datele dumneavoastră pe baza următoarelor temeiuri legale:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li>Executarea contractului de prestări servicii</li>
                <li>Îndeplinirea obligațiilor legale</li>
                <li>Consimțământul dumneavoastră (pentru comunicări de marketing)</li>
                <li>Interesul nostru legitim în îmbunătățirea serviciilor</li>
              </ul>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                5. Partajarea datelor
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Datele dumneavoastră pot fi partajate cu:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li>Instituții publice (primării, poliție, ANAF, RAR) în scopul procesării dosarului</li>
                <li>Furnizori de servicii tehnice (hosting, email)</li>
                <li>Autorități, dacă suntem obligați prin lege</li>
              </ul>
              <p className="text-slate-600 leading-relaxed">
                Nu vindem și nu partajăm datele dumneavoastră cu terți în scopuri de marketing.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                6. Perioada de stocare
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Păstrăm datele dumneavoastră atât timp cât este necesar pentru îndeplinirea 
                scopurilor pentru care au fost colectate și pentru respectarea obligațiilor 
                legale de arhivare (de regulă, 5 ani de la finalizarea serviciului).
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                7. Drepturile dumneavoastră
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Conform GDPR, aveți următoarele drepturi:
              </p>
              <ul className="text-slate-600 space-y-2">
                <li><strong>Dreptul de acces:</strong> să solicitați informații despre datele prelucrate</li>
                <li><strong>Dreptul la rectificare:</strong> să solicitați corectarea datelor inexacte</li>
                <li><strong>Dreptul la ștergere:</strong> să solicitați ștergerea datelor, în anumite condiții</li>
                <li><strong>Dreptul la restricționare:</strong> să solicitați limitarea prelucrării</li>
                <li><strong>Dreptul la portabilitate:</strong> să primiți datele într-un format structurat</li>
                <li><strong>Dreptul la opoziție:</strong> să vă opuneți prelucrării în anumite cazuri</li>
              </ul>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                8. Securitatea datelor
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Implementăm măsuri tehnice și organizatorice adecvate pentru protejarea 
                datelor dumneavoastră împotriva accesului neautorizat, pierderii sau distrugerii, 
                incluzând criptarea datelor și accesul restricționat.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                9. Cookie-uri
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Website-ul nostru folosește cookie-uri pentru a îmbunătăți experiența 
                utilizatorului și pentru funcționalități esențiale (autentificare, 
                salvarea preferințelor). Puteți gestiona preferințele cookie din browser.
              </p>

              <h2 className="font-display text-xl font-semibold text-slate-900 mt-8">
                10. Contact DPO
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Pentru orice întrebări privind prelucrarea datelor personale sau 
                exercitarea drepturilor dumneavoastră, ne puteți contacta la:
              </p>
              <ul className="text-slate-600 space-y-1">
                <li>Email: office@andeni-inmatriculari.ro</li>
                <li>Telefon: +40 700 000 000</li>
              </ul>
              <p className="text-slate-600 leading-relaxed mt-4">
                De asemenea, aveți dreptul de a depune o plângere la Autoritatea Națională 
                de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP).
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Privacy;
